<template>
		<div class="carousel-box bottom-padding overflow">
			<div class="title-box no-margin">
			<h1 class="title">{{ results.category_name }}</h1>
			</div>
			
			<div class="clearfix"></div>
			
      <div class="row">
      <div class="bg span4" style="margin-top:20px;" v-for="result in results.products" :key="result.id">
				<router-link :to="'/' + result.cpage_name + '/' + result.page_name" style="width:96%;" class="product border">
				<div class="product-image">
					<img :src="decodeURI(result.image_path)" alt="" title="">
				</div>
				
				</router-link><!-- .product -->
        <div class="product-description" style="width:100%">
					<div class="vertical alig-center"  style="width:100%">
					<div style="margin-bottom:10px;margin-top:10px;" class="title">{{result.title}} <br> Weight: {{result.weight}}</div>


          <div  style="width:40%;" class="pull-left" v-if="result.size_list != ''">
            Size: <select  :id="'cboSize' + result.id" v-on:change="size_change(result)" v-model="result.size" class="pull-left" style="margin-left:8px;width:90%;font-size:12px;border:0;-webkit-appearance:menulist;-webkit-box-shadow:0 0px #fff, inset 0 0px 0px rgba(0,0,0,.15);">
              <option v-if="result.size_list == ''" value="" selected >none</option>
              <option v-for="(sz,index) in result.size_list.split(',')" :key="index" :value="sz">{{sz}}</option>
            </select></div>
          <div v-if="result.size_list == ''" style="width:65%;" class="pull-left"><div>Pcs:</div> <input type="number" class="" style="text-align:center;font-size:16px;width:75%;-webkit-box-shadow:0 0px #fff, inset 0 0px 0px rgba(0,0,0,.15);" min="1" step="1" :id="'txtqty' + result.id" v-model="result.qty" /></div>
          <div v-if="result.size_list != ''" style="width:25%;" class="pull-left"><div>Pcs:</div> <input type="number" class="" style="text-align:center;font-size:16px;width:75%;-webkit-box-shadow:0 0px #fff, inset 0 0px 0px rgba(0,0,0,.15);" min="1" step="1" :id="'txtqty' + result.id" v-model="result.qty" /></div>
          <div  style="width:35%" class="pull-right">
            <br>
            <button type="button" class="btn btn-default" v-on:click="numUp(result.id)" style="margin-right:5px"><i class="fa fa-plus"></i></button>
            <button type="button" class="btn btn-default"  v-on:click="numDown(result.id)" ><i class="fa fa-minus"></i></button>
          </div>

          <div class="">
            <button type="button" v-if="result.mode == '0'" :id="'btnAddToCart' + result.id.toString()" class="btn btnprimary-lg btnflat" v-on:click="btnAddToCart_click(result);" onclick="event.preventDefault();return false;" style="width:100%;margin-top:5px;">ADD TO CART</button>
            <button type="button" v-if="result.mode == '1'" :id="'btnUpdateCart' + result.id.toString()" class="btn btnprimary-lg btnflat" v-on:click="btnUpdateCart_click(result)"  onclick="event.preventDefault();return false;" style="width:100%;margin-top:5px;">UPDATE CART</button>
            
            </div>	
					</div>
				</div>
      </div>
				</div>
			
			</div>
</template>
<script>
//import axios from 'axios'
import Vue from 'vue'
import $ from 'jquery'
import {mapGetters, mapActions} from "vuex";
import Common from '@/common.js'
import OnLoad from 'vue-onload'
import Vue2TouchEvents from 'vue2-touch-events'

Vue.use(OnLoad);
Vue.use(Vue2TouchEvents)



export default {
	name:'ProductList',
   data: function(){
    return {
    results: [{category_name:"",products:[]}]
    }
  },  props: {
    msg: String
  },mounted: function() {

    //alert(this.$route.params.categoryId);
    this.loadOnMount();

    //axios.get("http://localhost/api/categories.php")
    //.then(response => {this.results = response.data})
    
  },
  computed:mapGetters(["Session","Cart","CartCount"]),
  watch: {
    //Session(newValue) { this.get_session_response(newValue)  },
    Cart(newValue) { this.response_cart_items(newValue)  },
    //CartCount(newValue) { this.results.cart_count = newValue  },
    $route() {
        // react to route changes...
        this.loadOnMount()
        //alert(this.$route.query.pg);
    }
  },methods:{
          ...mapActions(["addToCart","updateCartItem","getCart"]),
          loadOnMount: function()
          {
              this.getCart();
              Common.callServerFunction("Items/ItemController::GetCategoryItems",this.get_response,{'category':this.$route.params.categoryId},"Item");
          },btnUpdateCart_click(result)
          {

            var size = "";
            var qty = result.pack;

            if(result.size_list != "")
              {
                size = $("#cboSize" + result.id).val();
              }
              qty = $("#txtqty" + result.id).val();

              //alert(JSON.stringify({'id':result.id,'qty':qty,'sizes':size}));

              //this.updateCartItem({'id':result.id,'qty':qty,'sizes':size});
              
              Common.callServerFunction("Cart/CartController::UpdateCartItem",this.get_update_cart_response,{'id':result.id,'qty':qty,'sizes':size},"Cart");
          },
          size_change(item)
          {
            //alert(JSON.stringify(this.Cart));
            item.mode = 0;
            this.Cart.forEach((Citem) =>{
                if(Citem.id == item.id && Citem.size == item.size)
                {
                  item.qty = Citem.qty;
                  item.mode = 1;
                }
            });
              
          },numUp(id)
          {
            var val = $("#txtqty" + id.toString()).val();
            if(val != "")
            {
              $("#txtqty" + id.toString()).val(parseInt(val)+1);
            }else
            {
              $("#txtqty" + id.toString()).val(1);
            }
          },
          numDown(id)
          {
            var val = $("#txtqty" + id.toString()).val();
            if(val != "")
            {
              if(parseInt(val) > 1)
              { 
                $("#txtqty" + id.toString()).val(parseInt(val) - 1);
              }else
              {
                $("#txtqty" + id.toString()).val(1);
              }
            }else
            {
              $("#txtqty" + id.toString()).val(1);
            }
          },
          btnAddToCart_click:function(item)
          { 
            
            if(event.target.tagName === "BUTTON")
            {
              var rid = item.id;
              var qty = 1;
              var cid = item.category_id;
              var price = item.price;
              var img = item.image_path;
              var pname = item.title;
              var weight = item.weight;
              var size = "";

              if(item.size_list != "")
              {
                size = $("#cboSize" + rid).val();
              }
              qty = $("#txtqty" + rid).val();

              this.addToCart({'pid':rid,'price':price,'qty':qty,'img':img,'cid':cid,'pname':pname,'size':size,'weight':weight,'pack':item.pack});
              this.loadOnMount();

              //Common.callServerFunction("Cart/CartController::AddToCart",this.response_btnAddToCart_click,{'pid':rid,'price':price,'qty':qty,'img':img,'cid':cid,'pname':pname},event);
            }

          },   
          touchHandler (event) {
            
            var purl =  $(event.target).attr('href');
            if(purl != undefined)
            {
              this.$router.push(purl);
            }else
            {
              purl = $(event.target).parent().attr('href');
              this.$router.push(purl);
            }

            //console.log($(event.target).parent())  // May be left / right / top / bottom
        },response_cart_items:function(newValue)
        {
           if(newValue != ""){
              this.results.cart = newValue;
            } 
            Common.callServerFunction("Items/ItemController::GetCategoryItems",this.get_response,{'category':this.$route.params.categoryId},"Item");
            //this.loadOnMount();
        },
        get_update_cart_response:function(response)
        {
            this.results.cart = JSON.parse(response);
            this.getCart();
            //this.loadOnMount();
        },
          get_response:function(response)
          {	
            var rdata = JSON.parse(response);
            this.results = rdata;
            if(rdata.category_name == ""){
                //this.$router.push("/404");
            }
                var jimage = [];
                Common.startAjaxLoader();
                rdata.products.forEach((item) => {
                    //console.log(item.image_path + " - " + index);
                    this.Cart.forEach((Citem) =>{
                        if(Citem.id == item.id)
                        {
                            item.qty = Citem.qty;
                            item.size = Citem.size;
                            item.mode = 1;
                        }
                    });
                    jimage.push(item.image_path)
                });
                this.preload = false
                this.$nextTick(function() {
                  this.$images.preload(jimage,
                    (completed, progress) => {
                      // progress indicator from 0 (no image loaded yet) to 1 (all images loaded)
                      console.log(Math.round(progress * 100))
                      // completed = true when all images are loaded
                      if (completed) {
                        this.preload = true
                        console.log(completed);
                        eval('loadFunctions();');
                        Common.stopAjaxLoader();
                      }
                    }
                  )
                })

                //$(".item").eq(0).addClass('item active');


                          //$.get('./js/main.js', function(data) {
                        //eval(data);
                        //eval('setTimeout(loadFunctions(),1000);');

                //});
                
         }   
   }  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
